import { render, staticRenderFns } from "./ImageTemplateProduct.vue?vue&type=template&id=5abdd5cc&scoped=true&"
import script from "./ImageTemplateProduct.vue?vue&type=script&lang=js&"
export * from "./ImageTemplateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abdd5cc",
  null
  
)

export default component.exports